import { UATrackingProps } from 'modules/tracking/GA4';
import { GA4Tracking } from 'modules/tracking/GA4/GA4Tracking';
import { type TrackingCategory } from 'modules/tracking/UAEventTracking';

const eventCategory: TrackingCategory = 'modiface';

enum Actions {
    openModifaceModal = 'openModifaceModal',
    showGuide = 'showGuide',
    guideSlide = 'guideSlide',
    guideLetsDoIt = 'guideLetsDoIt',
    colorVariant = 'colorVariant',
    liveMode = 'liveMode',
    photoMode = 'photoMode'
}

const eventAction = Actions;

const ua = {
    eventCategory,
    eventAction
};

const modifaceGA4Tracking = (params: Omit<UATrackingProps, 'context' | 'category'>) => {
    GA4Tracking({
        context: 'modiface',
        category: 'advisory',
        ...params
    });
};

export const modifaceTracking = Object.assign(modifaceGA4Tracking, {
    liveMode: () => {
        modifaceGA4Tracking({
            eventName: 'modiface_activated',
            eventParams: [{ param_name: 'modiface_mode', param_value: 'live_mode' }]
        });
    },
    photoMode: () => {
        modifaceGA4Tracking({
            eventName: 'modiface_activated',
            eventParams: [{ param_name: 'modiface_mode', param_value: 'photo_mode' }]
        });
    },
    showGuide: () => {
        modifaceGA4Tracking({
            eventName: 'show_more',
            eventParams: [{ param_name: 'show_more_type', param_value: 'modiface_guide' }]
        });
    },
    openModal: (label) => {
        modifaceGA4Tracking({
            eventName: 'open_modal',
            eventParams: [
                { param_name: 'modal_type', param_value: 'modiface' },
                { param_name: 'trigger_origin', param_value: label }
            ]
        });
    }
});

export default ua;
